import { TOOLBAR_BUTTON_SX } from "@/controls/buttons/toolbarButton";
import { ResetFiltersButton } from "@/controls/buttons/ResetFiltersButton";
import { Box, Button } from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers";
import type { Moment } from "moment";
import { ExcelButton } from "@/controls/buttons/ExcelButton";

interface Props {
	start: Moment;
	end: Moment;
	onStartChange: (date: Moment | null) => void;
	onEndChange: (date: Moment | null) => void;
	onLastTwelveMonths: () => void;
	onReset: () => void;
	onExportExcel: () => void;
	canReset: boolean;
}

export const ProductTypesStatisticsToolbar = ({
	start,
	end,
	onStartChange,
	onEndChange,
	onLastTwelveMonths,
	onReset,
	onExportExcel,
	canReset,
}: Props) => {
	return (
		<Box
			sx={{
				display: "flex",
				alignItems: "center",
				gap: 1,
				px: 1.5,
				py: 0.75,
				flexWrap: "wrap",
			}}
		>
			<Box sx={{ minWidth: 150, maxWidth: 170 }}>
				<DatePicker
					label="Start"
					format="MM/DD/YYYY"
					value={start}
					maxDate={end}
					onChange={onStartChange}
					slotProps={{ textField: { size: "small", fullWidth: true } }}
				/>
			</Box>
			<Box sx={{ minWidth: 150, maxWidth: 170 }}>
				<DatePicker
					label="End"
					format="MM/DD/YYYY"
					value={end}
					minDate={start}
					onChange={onEndChange}
					slotProps={{ textField: { size: "small", fullWidth: true } }}
				/>
			</Box>

			<Button
				size="medium"
				variant="contained"
				onClick={onLastTwelveMonths}
				sx={TOOLBAR_BUTTON_SX}
			>
				Last 12 Months
			</Button>

			<ResetFiltersButton onClick={onReset} disabled={!canReset} />

			<Box sx={{ ...TOOLBAR_BUTTON_SX, flexGrow: 1, minWidth: 8 }} />

			<Box sx={{ width: 200 }}>
				<ExcelButton handleExportToExcel={onExportExcel} />
			</Box>
		</Box>
	);
};
